/**
 * KLUBS Search Integration v3
 * Injecte les boutiques clubs dans la colonne gauche de la popup native Minimog,
 * AVANT les suggestions — en respectant exactement les classes et structure du thème.
 */
(function () {
  'use strict';

  var clubsData = null;
  var isFetching = false;
  var debounceTimer = null;
  var CONFIG = null; // Will be read from DOM once

  /* ─── Lire la config depuis les attributs data du snippet ────────────── */
  function readConfig() {
    var el = document.getElementById('klubs-search-config');
    if (!el) return null;
    return {
      enable:            el.getAttribute('data-enable') !== 'false',
      apiUrl:            el.getAttribute('data-api-url') || 'https://app.klubs.pro/api/clubs',
      title:             el.getAttribute('data-title') || 'Boutiques officielles',
      maxResults:        parseInt(el.getAttribute('data-max-results') || '3', 10),
      showProductsCount: el.getAttribute('data-show-products-count') !== 'false',
      showBadge:         el.getAttribute('data-show-badge') !== 'false'
    };
  }

  /* ─── Fetch unique, avec cache mémoire ───────────────────────────────── */
  function fetchClubs(cfg) {
    if (clubsData !== null || isFetching) return Promise.resolve(clubsData);
    isFetching = true;
    return fetch(cfg.apiUrl)
      .then(function (r) { return r.ok ? r.json() : { clubs: [] }; })
      .then(function (json) {
        clubsData = json.clubs || [];
        isFetching = false;
        return clubsData;
      })
      .catch(function (e) {
        console.error('KLUBS API:', e);
        clubsData = [];
        isFetching = false;
        return clubsData;
      });
  }

  /* ─── Normalisation des chaînes (accents, casse, trim) ──────────────── */
  function norm(s) {
    return String(s || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  /* ─── Filtre les clubs selon la saisie ──────────────────────────────── */
  function filterClubs(clubs, q, max) {
    if (!q || q.trim().length < 1) return [];
    var ql = norm(q);
    return clubs.filter(function (c) {
      return norm(c.name).indexOf(ql) > -1 ||
             norm(c.slug).indexOf(ql) > -1 ||
             norm(c.city).indexOf(ql) > -1 ||
             norm(c.sport).indexOf(ql) > -1 ||
             norm(c.postalCode).indexOf(ql) > -1 ||
             norm(c.type).indexOf(ql) > -1;
    }).slice(0, max);
  }

  /* KLUBS (13/10/2026) : l'annuaire renvoie le logo d'origine (pour les logos du moteur, le fichier
     d'impression Cloudinary, 250 à 520 Ko) ; affiché en 52 à 64 px, on demande une vignette. */
  function logoThumb(u) {
    u = String(u || '');
    if (u.indexOf('res.cloudinary.com/') > -1 && u.indexOf('/image/upload/') > -1) return u.replace('/image/upload/', '/image/upload/w_160,c_limit,f_auto,q_auto/');
    if (/^(https?:)?\/\/(cdn\.shopify\.com|klubs\.pro\/cdn)\//.test(u) && u.indexOf('width=') < 0) return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=160';
    return u;
  }

  /* ─── Crée le HTML d'une card club, en reprenant les classes Minimog ── */
  function buildClubItem(c, cfg) {
    var initials = (c.name || 'K').substring(0, 2).toUpperCase();

    /* Logo ou initiales */
    var logoInner = c.logoUrl
      ? '<img src="' + escape(logoThumb(c.logoUrl)) + '" alt="' + escape(c.name) + '" width="52" height="52" loading="lazy">'
      : '<span class="klubs-club-initials" style="background:' + escape(c.color || '#111') + '">' + escape(initials) + '</span>';

    /* Sous-ligne */
    var parts = [];
    if (c.sport) parts.push(escape(c.sport));
    if (c.city)  parts.push(escape(c.city));
    if (!parts.length) parts.push('Boutique officielle');
    if (cfg.showProductsCount && c.productsCount > 0) {
      parts.push(c.productsCount + '\u00a0produit' + (c.productsCount > 1 ? 's' : ''));
    }
    var subline = parts.join('\u00a0\u00b7 ');

    return (
      '<li class="m-predictive-search__list-item klubs-club-item">' +
        '<a href="' + escape(c.publicUrl) + '" class="m-search-item klubs-club-link" tabindex="-1">' +
          '<div class="klubs-club-logo">' + logoInner + '</div>' +
          '<div class="klubs-club-info">' +
            '<p class="klubs-club-name">' + escape(c.name) + '</p>' +
            '<p class="klubs-club-subline">' + subline + '</p>' +
          '</div>' +
          '<svg class="klubs-club-chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"></polyline></svg>' +
        '</a>' +
      '</li>'
    );
  }

  /* Échappe les valeurs dans les attributs HTML */
  function escape(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  /* ─── Injection dans la colonne gauche de la popup ───────────────────── */
  function renderPopupClubs(filtered, cfg) {
    /* Cherche la colonne gauche (premier group) dans le résultat natif Minimog */
    var resultWrapper = document.querySelector('[data-predictive-search] [data-search-items-wrapper]');
    if (!resultWrapper) return;

    /* Supprime l'éventuel bloc KLUBS précédent */
    var existing = resultWrapper.querySelector('.klubs-clubs-section');
    if (existing) existing.remove();

    /* Si 0 résultat : rien */
    if (filtered.length === 0) return;

    /* Trouve le premier m-search-result__group (colonne gauche) */
    var leftGroup = resultWrapper.querySelector('.m-search-result__group-wrapper > .m-search-result__group');
    if (!leftGroup) {
      /* Si les suggestions n'existent pas encore (ex: API pas encore revenue), on crée un wrapper */
      var groupWrapper = resultWrapper.querySelector('.m-search-result__group-wrapper');
      if (!groupWrapper) return;
      leftGroup = document.createElement('div');
      leftGroup.className = 'm-search-result__group';
      groupWrapper.insertBefore(leftGroup, groupWrapper.firstChild);
    }

    /* Crée le bloc KLUBS */
    var section = document.createElement('div');
    section.className = 'klubs-clubs-section';
    section.innerHTML =
      '<h2 class="m-search-result__heading h5 klubs-clubs-heading">' + escape(cfg.title) + '</h2>' +
      '<ul class="m-search-result__results-list klubs-clubs-list" role="group" aria-label="' + escape(cfg.title) + '">' +
        filtered.map(function (c) { return buildClubItem(c, cfg); }).join('') +
      '</ul>';

    /* Insère avant les suggestions existantes */
    leftGroup.insertBefore(section, leftGroup.firstChild);
  }

  /* ─── Effacer le bloc KLUBS ─────────────────────────────────────────── */
  function clearPopupClubs() {
    var existing = document.querySelector('[data-predictive-search] .klubs-clubs-section');
    if (existing) existing.remove();
  }

  /* ─── Observer la popup pour détecter quand Minimog injecte les résultats ── */
  function observePredictiveSearchResult(cfg) {
    var predictiveContainer = document.querySelector('[data-search-popup] [data-predictive-search]');
    if (!predictiveContainer) return;

    var lastQuery = '';

    var observer = new MutationObserver(function () {
      var input = document.querySelector('[data-search-popup] [data-search-input]');
      if (!input) return;
      var query = input.value;

      if (query === lastQuery) return; // Pas de changement
      lastQuery = query;

      if (!query || query.length < 1) {
        clearPopupClubs();
        return;
      }

      if (!clubsData) {
        fetchClubs(cfg).then(function (clubs) {
          var filtered = filterClubs(clubs, query, cfg.maxResults);
          renderPopupClubs(filtered, cfg);
        });
      } else {
        var filtered = filterClubs(clubsData, query, cfg.maxResults);
        renderPopupClubs(filtered, cfg);
      }
    });

    observer.observe(predictiveContainer, { childList: true, subtree: true });
  }

  /* ─── Pré-chargement au focus ────────────────────────────────────────── */
  function prefetchOnFocus(cfg) {
    var input = document.querySelector('[data-search-popup] [data-search-input]');
    if (!input) return;
    input.addEventListener('focus', function () {
      if (!clubsData && !isFetching) fetchClubs(cfg);
    }, { once: true });
  }

  /* ─── Page /search ───────────────────────────────────────────────────── */
  function initPageSearch(cfg) {
    var container = document.getElementById('klubs-page-search-clubs');
    if (!container) return;

    var urlParams = new URLSearchParams(window.location.search);
    var q = (urlParams.get('q') || '').trim();
    if (!q) return;

    fetchClubs(cfg).then(function (clubs) {
      var filtered = filterClubs(clubs, q, cfg.maxResults * 2);
      if (filtered.length === 0) { container.innerHTML = ''; return; }

      var html =
        '<div class="klubs-page-clubs-section">' +
          '<h2 class="klubs-page-clubs-heading">' + escape(cfg.title) + '</h2>' +
          '<ul class="klubs-page-clubs-list">' +
            filtered.map(function (c) { return buildClubItem(c, cfg); }).join('') +
          '</ul>' +
        '</div>';
      container.innerHTML = html;
    });
  }

  /* ─── Init principale ────────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    CONFIG = readConfig();
    if (!CONFIG || !CONFIG.enable) return;

    prefetchOnFocus(CONFIG);
    observePredictiveSearchResult(CONFIG);
    initPageSearch(CONFIG);
  });
})();
